/* !! DO NOT EDIT manually, this file is AUTO-GENERATED. Any edits to the file will be overwritten during the build. Edits should be made to the SVG with a matching name */ import * as React from "react";
const SvgBoldRussian = (props)=>/*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 2048 2048",
        width: "1em",
        height: "1em",
        ...props
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m1511 930 537 734h-395l-415-607q-11-17-20-34t-18-36h-4v677H886V987h-5q-16 37-38 70l-416 607H33l537-734L74 256h377l392 589q11 16 20 32t18 33h5V256h310v654h4q8-17 17-33t21-32l392-589h378l-497 674z"
    }));
export default SvgBoldRussian;
